
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"48","height":"48","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#53CB72","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M41 24.25l2.027 1.858A3 3 0 0144 28.32v3.93a3 3 0 01-3 3h-.01A3 3 0 0138 38H8a3 3 0 01-3-3V13a3 3 0 013-3h30a3 3 0 013 3v11.25z","opacity":".202"}}),_c('path',{attrs:{"d":"M38 10a3 3 0 013 3v11.25l2.027 1.858A3 3 0 0144 28.32v3.93a3 3 0 01-3 3h-.01A3 3 0 0138 38H8a3 3 0 01-3-3V13a3 3 0 013-3h30zm0 1H8a2 2 0 00-2 2v22a2 2 0 002 2h30a2 2 0 002-2V13a2 2 0 00-2-2zm3 14.606v8.644a2 2 0 002-2v-3.93a2 2 0 00-.649-1.475L41 25.606zM19 14.5a9.5 9.5 0 110 19 9.5 9.5 0 010-19zm0 1a8.5 8.5 0 100 17 8.5 8.5 0 000-17z"}})])])
          )
        }
      }
    